import { CSSProperties } from "react";

const closedStyle: CSSProperties = { display: "none" };

export function hideWhenClosed(isOpen: boolean): Readonly<CSSProperties> | undefined {
    return isOpen ? undefined : closedStyle;
}
